// Local translations
export const T = {
  en_GB: {
    checkYourEmail: "Check your email",
    ifAccountExists: (email: string, organization: string) =>
      `If an account exists for ${email} in ${organization}, you will receive a password reset link shortly.`,
    didntReceiveEmail: "Didn't receive the email? Check your spam folder or try again.",
    tryAgain: "Try again",
    backToLogin: "Back to login",
    forgotPassword: "Forgot password?",
    enterOrgFirst: "First, tell us which organization you belong to",
    enterEmailForReset: "Enter your email and we'll send you a reset link",
    organizationIdentifier: "Organization Identifier",
    enterOrgIdentifier: "Please enter your organization identifier",
    orgNotFound: "Organization not found",
    enterOrgUniqueId: "Enter your organization's unique identifier",
    checking: "Checking...",
    continue: "Continue",
    enterYourEmail: "Please enter your email address",
    failedToSendReset: "Failed to send reset email",
    email: "Email",
    sending: "Sending...",
    sendResetLink: "Send reset link",
    ssoPasswordNote: (sso: string) =>
      `If you sign in with ${sso}, your password is managed there and cannot be reset here.`,
  },
  nb_NO: {
    checkYourEmail: "Sjekk e-posten din",
    ifAccountExists: (email: string, organization: string) =>
      `Hvis en konto eksisterer for ${email} i ${organization}, vil du motta en lenke for tilbakestilling av passord snart.`,
    didntReceiveEmail: "Mottok du ikke e-posten? Sjekk spam-mappen eller prøv igjen.",
    tryAgain: "Prøv igjen",
    backToLogin: "Tilbake til innlogging",
    forgotPassword: "Glemt passord?",
    enterOrgFirst: "Fortell oss først hvilken organisasjon du tilhører",
    enterEmailForReset: "Oppgi e-postadressen din, så sender vi deg en tilbakestillingslenke",
    organizationIdentifier: "Organisasjonsidentifikator",
    enterOrgIdentifier: "Vennligst oppgi organisasjonsidentifikatoren din",
    orgNotFound: "Organisasjon ikke funnet",
    enterOrgUniqueId: "Oppgi organisasjonens unike identifikator",
    checking: "Sjekker...",
    continue: "Fortsett",
    enterYourEmail: "Vennligst oppgi e-postadressen din",
    failedToSendReset: "Kunne ikke sende tilbakestillings-e-post",
    email: "E-post",
    sending: "Sender...",
    sendResetLink: "Send tilbakestillingslenke",
    ssoPasswordNote: (sso: string) =>
      `Hvis du logger inn med ${sso}, administreres passordet ditt der og kan ikke tilbakestilles her.`,
  },
} as const;
